// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YxRyMamAGrf8AMCdZPNt{display:flex;align-items:center;justify-content:space-between}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/AgentKnowledgeBase/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,6BAAA","sourcesContent":[".dataSourcesContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataSourcesContainer": `YxRyMamAGrf8AMCdZPNt`
};
export default ___CSS_LOADER_EXPORT___;
